import CoachSettings from './CoachSettings';

export default CoachSettings;
